<template>
    <div id="weekday">
        <div style="width: 48%;float:left;margin-bottom:10px">
            <div style="border: 2px solid #eee;height: 68px;width:100%;display: flex;justify-content: space-around;align-items: center;margin: 10px 0" v-if="!onOff">
                <div style="display:flex;justify-content: center;align-items: center;flex-direction:column;cursor:pointer"  @click="openMedicalVisitModel">
                    <img src="../../../../assets/images/institutionIcon.png" width="40" height="40">
                    <span style="font-size: 12px;color:#59C95D;margin-top: 5px">医务拜访</span>
                </div>
                <div style="display:flex;justify-content: center;align-items: center;flex-direction:column;cursor:pointer" @click="openMedicalVisitModelStore">
                    <img src="../../../../assets/images/storeIcon.png" width="40" height="40">
                    <span style="font-size: 12px;color:#FE8D40;margin-top: 5px">门店巡查</span>
                </div>
                <div style="display:flex;justify-content: center;align-items: center;flex-direction:column;cursor:pointer" @click="openMedicalVisitModelDis">
                    <img src="../../../../assets/images/businessIcon.png" width="45" height="40">
                    <span style="font-size: 12px;color:#F65272;margin-top: 5px">商务拜访</span>
                </div>
                <div style="display:flex;justify-content: center;align-items: center;flex-direction:column;cursor:pointer" @click="openMedicalVisitModelMee">
                    <img src="../../../../assets/images/meetingIcon.png" width="40" height="40">
                    <span style="font-size: 12px;color:#9A3BFE;margin-top: 5px">会议/活动</span>
                </div>
                <div style="display:flex;justify-content: center;align-items: center;flex-direction:column;cursor:pointer" @click="openMedicalVisitModelCoach">
                    <img src="../../../../assets/images/coachIcon.png" width="40" height="40">
                    <span style="font-size: 12px;color:#2689F7;margin-top: 5px">辅导/协访</span>
                </div>
            </div>
            <div style="margin-bottom: 10px;width: 100%">
                <draggable v-model="data" handle=".img" @end="end" animation="600">
                    <transition-group>
                        <el-row style="border-bottom: 1px solid #eee;padding: 10px 0" v-for="(item,i) in data" :key="i">
                            <el-col style="display: flex;align-items: center;" v-if="item.activity_category=='INSTITUTION_VISIT'||item.activity_category=='HCP_CALL'">
                                <el-col :span="4" style="color: #59C95D">医务拜访</el-col>
                                <el-col :span="14">
                        <span style="display: inline-block;border:1px solid #FF9901;color: #FF9901;padding: 0 6px;border-radius: 6px;line-height: 25px;font-size: 14px">
                            {{item.institution_name}}{{item.dept_name | titleFilter}}{{ item.hcp_name | titleFilter}}
                        </span>
                                </el-col>
                                <el-col :span="5" style="margin-left: 10px;display: flex;align-items: center;justify-content: space-between" v-if="!onOff">
                                    <el-button type="danger" size="mini" @click="deleteOne(item,i)" style="background: #ED3B3F;border: 1px solid #ED3B3F">删除</el-button>
                                    <img class="img" src="../../../../assets/images/dragIcon.png" width="27" height="23" style="cursor: pointer">
                                </el-col>
                            </el-col>
                            <el-col style="display: flex;align-items: center;" v-if="item.activity_category=='STORE_INSPECTION'">
                                <el-col :span="4" style="color: #FE8D40">门店巡查</el-col>
                                <el-col :span="14">
                        <span style="display: inline-block;border:1px solid #FF9901;color: #FF9901;padding: 0 6px;border-radius: 6px;line-height: 25px;font-size: 14px">
                            {{item.store_name}}
                        </span>
                                </el-col>
                                <el-col :span="5" style="margin-left: 10px;display: flex;align-items: center;justify-content: space-between" v-if="!onOff">
                                    <el-button type="danger" size="mini" @click="deleteOne(item,i)" style="background: #ED3B3F;border: 1px solid #ED3B3F">删除</el-button>
                                    <img class="img" src="../../../../assets/images/dragIcon.png" width="27" height="23" style="cursor: pointer">
                                </el-col>
                            </el-col>
                            <el-col style="display: flex;align-items: center;" v-if="item.activity_category=='DISTRIBUTOR_VISIT'||item.activity_category=='CONTACT_CALL'">
                                <el-col :span="4" style="color: #F65272" >商务拜访</el-col>
                                <el-col :span="14">
                        <span style="display: inline-block;border:1px solid #FF9901;color: #FF9901;padding: 0 6px;border-radius: 6px;line-height: 25px;font-size: 14px">
                            {{item.distributor_name}}{{item.job_title | titleFilter}}{{ item.contact_name | titleFilter}}
                        </span>
                                </el-col>
                                <el-col :span="5" style="margin-left: 10px;display: flex;align-items: center;justify-content: space-between" v-if="!onOff">
                                    <el-button type="danger" size="mini" @click="deleteOne(item,i)" style="background: #ED3B3F;border: 1px solid #ED3B3F">删除</el-button>
                                    <img class="img" src="../../../../assets/images/dragIcon.png" width="27" height="23" style="cursor: pointer">
                                </el-col>
                            </el-col>
                            <el-col style="display: flex;align-items: center;" v-if="item.activity_category=='CAMPAIGN'">
                                <el-col :span="4" style="color: #9A3BFE" >会议/活动</el-col>
                                <el-col :span="14">
                        <span style="display: inline-block;border:1px solid #FF9901;color: #FF9901;padding: 0 6px;border-radius: 6px;line-height: 25px;font-size: 14px">
                             {{item.value1}}
                        </span>
                                </el-col>
                                <el-col :span="5" style="margin-left: 10px;display: flex;align-items: center;justify-content: space-between" v-if="!onOff">
                                    <el-button type="danger" size="mini" @click="deleteOne(item,i)" style="background: #ED3B3F;border: 1px solid #ED3B3F">删除</el-button>
                                    <img class="img" src="../../../../assets/images/dragIcon.png" width="27" height="23" style="cursor: pointer">
                                </el-col>
                            </el-col>
                            <el-col style="display: flex;align-items: center;" v-if="item.activity_category=='COACHING'">
                                <el-col :span="4" style="color: #2689F7" >辅导/协访</el-col>
                                <el-col :span="14">
                        <span style="display: inline-block;border:1px solid #FF9901;color: #FF9901;padding: 0 6px;border-radius: 6px;line-height: 25px;font-size: 14px">
                            {{item.value1}}
                        </span>
                                </el-col>
                                <el-col :span="5" style="margin-left: 10px;display: flex;align-items: center;justify-content: space-between" v-if="!onOff">
                                    <el-button type="danger" size="mini" @click="deleteOne(item,i)" style="background: #ED3B3F;border: 1px solid #ED3B3F">删除</el-button>
                                    <img class="img" src="../../../../assets/images/dragIcon.png" width="27" height="23" style="cursor: pointer">
                                </el-col>
                            </el-col>
                        </el-row>
                    </transition-group>
                </draggable>
            </div>
        </div>
        <div style="width: 50%;float: right;margin-left: 2%;margin-top:10px;height: 640px;position: relative">
            <el-amap :vid="mapId" :plugin="plugin" :center="center" :zoom="zoom" :amapManager="amapManager">
                <el-amap-marker
                        :position="center.position" :template="center.template" v-for="center in centers">
                </el-amap-marker>
            </el-amap>
            <div align="center" style="position: absolute;top:50px;left:calc(50% - 65px)">
                 <span style="position: relative;
                    top: -35px;
                    background-color: #b6bbbf;
                    border: 1px solid #ccc;
                    color: #fff;
                    font-size: 14px;
                    border-radius: 5px;
                    padding: 2px 5px;
                    ">当日总行程：{{distance}}公里</span>
            </div>
        </div>
        <el-dialog
                :visible.sync="medicalVisitModel"
                width="60%"
                :show-close="false"
                :before-close="handleClose"
                style="vertical-align: center;: #FFF9F3">
            <div>
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">客户列表
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click="saveModelIn">
                                确定
                            </el-button>
                            <el-button type="danger" size="small" @click="closeModelIn">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div id="speak" style="margin-top: 20px;">
                    <el-row>
                        <el-col :span="11" style="border-right: 1px solid #979797; height: 450px;overflow: auto">
                            <el-col v-for="(item,i) in institutionModel.institutionsArray"
                                    :span="22"
                                    style="border: 1px solid #979797;margin-bottom: 10px;"
                                    :style="{'background': item.onoff ? 'rgba(74,144,226,0.1)' : 'white'}"
                            >
                                <div style="width: 12%;height: 96px;float: left;text-align: center;line-height: 140px">
                                    <img @click="imgClick(item,'inCheckIns')" v-if="item.onoff === true"
                                         :src="inCheck"/>
                                    <img @click="imgClick(item,'noCheckIns')" v-else :src="noCheck"/>
                                </div>
                                <div style="width: 88%;float: left;margin-top: 5px" @click="getInstutionsHcpList(item)">
                                    <p style="width:220px;margin: 10px 10px;font-weight: bold;font-size: 15px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{item.institution_name}} </p>
                                    <span
                                            style="display: inline-block;padding: 4px;background: #FF9901;float: right;font-size: 12px;
                                        color: white;border-radius: 4px;margin-top: -28px;margin-right: 10px">{{item
                                    .last_name}}</span>
                                    <p style="margin: 0px 8px;margin-bottom: 30px;">
                                        <el-col :span="22" style="font-size: 12px; color: #B0B5B9;border: 1px solid transparent">
                                            {{item.address}}
                                        </el-col>
                                        <el-col :span="2">
                                            <i :class="['iconfont', 'el-icon-arrow-right']" style="color: #979797"></i>
                                        </el-col>
                                    </p>
                                    <span style="height: 20px;margin: 0 0 0 10px;color: #6BC235">
                                        {{item.institution_grade}}
                                    </span>
                                    <p style="overflow: hidden;color: #7ED321;margin: 0;padding: 0 10px">
                                        <span style="color: #3b99f7;float: right" v-if="item.cover_num>0">本月覆盖{{item.cover_num}}人</span>
                                        <span style="color: red;float: right" v-else>本月尚未覆盖</span>
                                        <span style="color: #3b99f7;float: right">&nbsp;|&nbsp; </span>
                                        <span style="color: #3b99f7;float: right" v-if="item.target_num>0">目标客户{{item.target_num}}人</span>
                                        <span style="color: red;float: right" v-else>暂无目标客户</span>
                                    </p>
                                </div>
                                <el-col style="margin-left: 14.5%;width: 88%">
                                        <span   v-for="(obj,j) in item.productArray"
                                                style="display: inline-block;padding: 4px;margin-bottom: 10px;
                                                background: #c680ff;color: white;border-radius: 4px;margin-right: 10px">
                                            {{obj.value1}}
                                        </span>
                                </el-col>

                            </el-col>
                        </el-col>
                        <el-col :span="13">
                            <el-row style="margin-left: 30px;height: 450px;overflow: auto;">
                                <el-col style="border: 1px solid #ededed;width:100%;margin-bottom: 15px;
                                   height: 100px;position:relative"
                                        v-for="(item,i) in institutionModel.institutionsHcpList"
                                        :style="{'background': item.onoff ? 'rgba(74,144,226,0.1)' : 'white'}">
                                    <div  @click="imgClick(item,'')" style="height: 100px">
                                        <el-col :span="4" style="margin: 0 10px">
                                            <div style="width: 60px;height: 60px;border-radius: 50%;
                                                margin:20px auto 0;overflow: hidden;position: relative">
                                                <img src="../../../../assets/images/chat_header_image.png" width="100%" alt=""
                                                     style=" position: absolute;left: 50%;top: 50%;
                                                         transform: translate(-50%,-50%);
                                            ">
                                            </div>

                                        </el-col>

                                        <span style="position: absolute;top: 20px">
                                                 <span style="color: #4D586D;font-size: 15px;float: left">{{item.hcp_name}}</span>
                                                 <span v-if="item.pro_title !== ''"
                                                       style="color: #fff;background: #FF9901;border-radius:5px;
                                                         padding: 4px;font-size: 12px;float: left;margin-top: -2px;margin-left: 4px;
                                                         display:inline-block">
                                                     {{item.pro_title}}</span>
                                            </span>
                                        <span style="position: absolute;top: 45px;width: 60%">
                                              <span style="font-size: 13px;color:#B0B5B9">
                                                 {{item.job_title +' | '+ item.dept_name}}
                                              </span>
                                                <p
                                                        style="font-size: 13px;color:#B0B5B9;margin-top: 4px;
                                                        width: 100%;margin-bottom:0px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">
                                                    {{item.institution_name}}
                                                </p>
                                                <p style="width: 100%;text-align: right;margin-top: 5px;
                                                font-size:12px;">
                                                   <span
                                                           :style="{'color': colorFun(item)}">{{item |
                                                       filter_covegr}}</span>
                                                </p>
                                            </span>

                                        <el-col :span="4" style="width: 100px; height: 100%;position: absolute;top:0;right:0;
text-align: center;line-height: 100px">

                                            <img v-if="item.onoff === true"
                                                 :src="inCheck"/>
                                            <img v-else :src="noCheck"/>

                                        </el-col>
                                    </div>
                                </el-col>

                            </el-row>
                        </el-col>
                        <el-col style="margin-top: 20px">
                            <span style="float: left;width:80px;line-height: 46px">已选择机构</span>
                            <el-card class="box-card">
                              <span  v-for="(item,i) in form.institutionsArray"
                                     style="display: inline-block;
                                      background: #FF9901;
                                      color: white;padding: 2px 6px;
                                      margin-top: 6px;
                                      margin-right: 10px;
                                      border-radius: 6px;
                                      line-height: 25px;font-size: 12px">
                                  {{item.institution_name}}{{item.dept_name | titleFilter}}{{ item.hcp_name | titleFilter}}
                                  </span>
                            </el-card>
                        </el-col>
                    </el-row>
                </div>
            </div>

        </el-dialog>
        <el-dialog
                :visible.sync="medicalVisitModelStore"
                width="45%"
                :show-close="false"
                :before-close="handleClose"
                style="vertical-align: center;: #FFF9F3">
            <div>
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">门店列表
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click="saveModelInStore">
                                确定
                            </el-button>
                            <el-button type="danger" size="small" @click="closeModelInStore">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div style="margin-top: 20px;">
                    <el-row>
                        <el-col :span="24" style=" height: 450px;overflow: auto">
                            <el-col v-for="(item,i) in storesArrayModel"
                                    :span="24"
                                    style="border: 1px solid #979797;margin-bottom:10px;width: 100%"
                                    :style="{'background': item.onoff ? 'rgba(74,144,226,0.1)' : 'white'}"
                            >
                                <div @click="storeImgClick(item)">
                                    <div style="width: 10%;height: 96px;float: left;text-align: center;line-height: 120px">
                                        <img v-if="item.onoff === true"
                                             :src="inCheck"/>
                                        <img v-else :src="noCheck"/>
                                    </div>
                                    <div style="width: 90%;float: left">
                                        <p
                                                style="margin: 10px 10px;font-weight: bold;font-size: 16px;">{{item.store_name}} </p>
                                        <span
                                                style="display: inline-block;padding: 4px;background: #FF9901;float: right;font-size: 12px;
                                        color: white;border-radius: 4px;margin-top: -28px;margin-right: 10px">{{item
                                    .last_name}}</span>
                                        <p style="margin: 0px 10px;margin-bottom: 15px;">
                                            <el-col :span="22" style="font-size: 13px; color: #B0B5B9;">
                                                {{item.address}}
                                            </el-col>
                                        </p>
                                        <el-col :span="24" style="height: 25px;line-height: 25px">
                                        <span
                                                style="margin-bottom: 8px;margin-left: 10px;color: #6BC235;float: left">{{item
                                            .retailstore_grade}}</span>
                                            <span style="margin-left:10px;color: #7ED321;padding-right: 10px;float: right">
                                            <span style="color: #3b99f7;float: right" v-if="item.inspection_num>0">本月巡店{{item.inspection_num}}次</span>
                                            <span style="color: red;float: right" v-else>本月暂未巡店</span>
                                            <span style="color: #3b99f7;float: right"> &nbsp;|&nbsp; </span>
                                            <span style="color: #3b99f7;float: right" v-if="item.clerk_num>0">店员{{item.clerk_num}}人</span>
                                            <span style="color: red;float: right" v-else>暂无店员</span>
                                        </span>
                                        </el-col>
                                        <el-col style="padding:0 10px">
                                        <span   v-for="(obj,j) in item.productArray"
                                                style="display: inline-block;padding: 4px;margin-bottom: 10px;
                                                background: #c680ff;color: white;border-radius: 4px;margin-right: 10px">
                                            {{obj.value1}}
                                        </span>
                                        </el-col>

                                    </div>
                                </div>
                            </el-col>
                        </el-col>
                        <el-col style="margin-top: 20px">
                            <span style="float: left;width:80px;line-height: 46px">已选择门店</span>
                            <el-card class="box-card">
                              <span  v-for="(item,i) in form.retailstoreArray"
                                     style="display: inline-block;
                                      background: #FF9901;
                                      color: white;padding: 2px 6px;
                                      margin-top: 6px;
                                      margin-right: 10px;
                                      border-radius: 6px;
                                      line-height: 25px;font-size: 12px">
                                  {{item.store_name}}
                                  </span>
                            </el-card>
                        </el-col>

                    </el-row>
                </div>
            </div>

        </el-dialog>
        <el-dialog
                :visible.sync="medicalVisitModelDis"
                width="60%"
                :show-close="false"
                :before-close="handleClose"
                style="vertical-align: center;: #FFF9F3">
            <div>
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">经销商列表
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click="saveModelInDis">
                                确定
                            </el-button>
                            <el-button type="danger" size="small" @click="closeModelInDis">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div style="margin-top: 20px;">
                    <el-row>
                        <el-col :span="11" style=" height: 450px;overflow: auto">
                            <el-col v-for="(item,i) in disArrayModel.distributorArray"
                                    :span="24"
                                    style="border: 1px solid #979797;margin-bottom: 10px;"
                                    :style="{'background': item.onoff ? 'rgba(74,144,226,0.1)' : 'white'}"
                            >
                                <div style="width: 10%;height: 96px;float: left;text-align: center;line-height: 120px">
                                    <img @click="disImgClick(item,'inCheckDis')" v-if="item.onoff === true"
                                         :src="inCheck"/>
                                    <img @click="disImgClick(item,'noCheckDis')" v-else :src="noCheck"/>
                                </div>
                                <div style="width: 90%;float: left;margin-top: 5px" @click="getDistributorContact(item)">
                                    <p
                                            style="margin: 10px 10px;font-weight: bold;font-size: 16px;">{{item.distributor_name}}
                                    </p>
                                    <span
                                            style="display: inline-block;padding: 4px;background: #FF9901;float: right;font-size: 12px;
                                        color: white;border-radius: 4px;margin-top: -28px;margin-right: 10px">{{item
                                    .last_name}}</span>
                                    <p style="margin: 0px 10px;margin-bottom: 15px;">
                                        <el-col v-if="item.address" :span="22" style="font-size: 13px; color: #B0B5B9;">
                                            {{item.address}}
                                        </el-col>
                                        <el-col v-else :span="22">&nbsp;</el-col>
                                        <el-col :span="2">
                                            <i :class="['iconfont', 'el-icon-arrow-right']" style="color: #979797"></i>
                                        </el-col>
                                    </p>
                                    <el-col :span="24" style="line-height: 25px;height: 25px">
                                        <span
                                                style="margin-bottom: 8px;margin-left: 10px;color: #6BC235;float: left">{{item
                                            .distributor_grade}}</span>
                                        <span style="margin-left:10px;color: #7ED321;padding-right: 10px;float: right">
                                            <span style="color: #3b99f7;float: right" v-if="item.inspection_num>0">本月拜访{{item.inspection_num}}次</span>
                                            <span style="color: red;float: right" v-else>本月暂未拜访</span>
                                            <span style="color: #3b99f7;float: right"> &nbsp;|&nbsp; </span>
                                            <span style="color: #3b99f7;float: right" v-if="item.contact_num>0">联系人{{item.contact_num}}名</span>
                                            <span style="color: red;float: right" v-else>暂无联系人</span>
                                        </span>
                                    </el-col>
                                    <el-col style="padding: 0 10px">
                                        <span   v-for="(obj,j) in item.productArray"
                                                style="display: inline-block;padding: 4px;margin-bottom: 10px;
                                                background: #c680ff;color: white;border-radius: 4px;margin-right: 10px">
                                            {{obj.value1}}
                                        </span>
                                    </el-col>

                                </div>

                            </el-col>
                        </el-col>
                        <el-col :span="13">
                            <el-row style="margin-left: 30px;height: 450px;overflow: auto;">
                                <el-col style="border: 1px solid #ededed;width:100%;margin-bottom: 15px;
                                   height: 100px;position:relative"
                                        v-for="(item,i) in disArrayModel.contactArray"
                                        :style="{'background': item.onoff ? 'rgba(74,144,226,0.1)' : 'white'}">
                                    <div  @click="disImgClick(item,'')" style="height: 100px">
                                        <el-col :span="4" style="margin: 0 10px">
                                            <div style="width: 60px;height: 60px;border-radius: 50%;
                                                margin:20px auto 0;overflow: hidden;position: relative">
                                                <img src="../../../../assets/images/chat_header_image.png" width="100%" alt=""
                                                     style=" position: absolute;left: 50%;top: 50%;
                                                         transform: translate(-50%,-50%);
                                            ">
                                            </div>

                                        </el-col>

                                        <span style="position: absolute;top: 20px">
                                                 <span style="color: #4D586D;font-size: 15px;float: left">{{item.contact_name}}</span>
                                                 <span v-if="item.pro_title"
                                                       style="color: #fff;background: #FF9901;border-radius:5px;
                                                         padding: 4px;font-size: 12px;float: left;margin-top: -2px;margin-left: 4px;
                                                         display:inline-block">
                                                     {{item.pro_title}}</span>
                                            </span>
                                        <span style="position: absolute;top: 45px;width: 60%">
                                              <span style="font-size: 13px;color:#B0B5B9" v-if="item.job_title">
                                                 {{item.job_title}}
                                              </span>
                                            <span v-else style="height: 18px">&nbsp;</span>
                                                <p
                                                        style="font-size: 13px;color:#B0B5B9;margin-top: 4px;
                                                        width: 100%;margin-bottom:0px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">
                                                    {{item.distributor_name}}
                                                </p>
                                            <!--                                                <p style="width: 100%;text-align: right;margin-top: 5px;-->
                                            <!--                                                font-size:12px;">-->
                                            <!--                                                   <span-->
                                            <!--                                                           :style="{'color': colorFun(item)}">{{item |-->
                                            <!--                                                       filter_covegr}}</span>-->
                                            <!--                                                </p>-->
                                            </span>

                                        <el-col :span="4" style="width: 100px; height: 100%;position: absolute;top:0;right:0;
text-align: center;line-height: 100px">

                                            <img v-if="item.onoff === true"
                                                 :src="inCheck"/>
                                            <img v-else :src="noCheck"/>

                                        </el-col>
                                    </div>
                                </el-col>

                            </el-row>
                        </el-col>
                        <el-col style="margin-top: 20px">
                            <span style="float: left;width:100px;line-height: 46px">已选择经销商</span>
                            <el-card class="box-card">
                              <span  v-for="(item,i) in form.distributorArray"
                                     style="display: inline-block;
                                      background: #FF9901;
                                      color: white;padding: 2px 6px;
                                      margin-top: 6px;
                                      margin-right: 10px;
                                      border-radius: 6px;
                                      line-height: 25px;font-size: 12px">
                                  {{item.distributor_name}}{{item.job_title | titleFilter}}{{ item.contact_name | titleFilter}}
                                  </span>
                            </el-card>
                        </el-col>

                    </el-row>
                </div>
            </div>

        </el-dialog>
        <el-dialog
                :visible.sync="medicalVisitModelMee"
                width="45%"
                :show-close="false"
                :before-close="handleClose"
                style="vertical-align: center;: #FFF9F3">
            <div>
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">选择会议/活动
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click="saveModelInMee">
                                确定
                            </el-button>
                            <el-button type="danger" size="small" @click="closeModelInMee">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div style="margin-top: 20px;">
                    <el-row>
                        <el-col :span="24" style=" height: 365px;overflow: auto">
                            <el-col v-for="(item,i) in meeArrayModel"
                                    :span="24"
                                    style="border: 1px solid #979797;margin-bottom: 10px;"
                                    :style="{'background': item.onoff ? 'rgba(74,144,226,0.1)' : 'white'}"

                            >
                                <div  @click="meeImgClick(item)">
                                    <div style="width: 10%;height: 60px;float: left;text-align: center;line-height: 75px">
                                        <img v-if="item.onoff === true"
                                             :src="inCheck"/>
                                        <img v-else :src="noCheck"/>
                                    </div>
                                    <div style="width: 90%;float: left">
                                        <p
                                                style="margin: 22px 10px 10px;font-weight: bold;font-size: 18px;">{{item.value1}}
                                        </p>
                                    </div>
                                </div>

                            </el-col>
                        </el-col>
<!--                        <el-col style="margin-top: 20px">-->
<!--                            <span style="float: left;width:80px;line-height: 46px">已选择会议/活动</span>-->
<!--                            <el-card class="box-card">-->
<!--                              <span  v-for="(item,i) in form.meetingArray"-->
<!--                                     style="display: inline-block;-->
<!--                                      background: #FF9901;-->
<!--                                      color: white;padding: 2px 6px;-->
<!--                                      margin-top: 6px;-->
<!--                                      margin-right: 10px;-->
<!--                                      border-radius: 6px;-->
<!--                                      line-height: 25px;font-size: 12px">-->
<!--                                  {{item.value1}}-->
<!--                                  </span>-->
<!--                            </el-card>-->
<!--                        </el-col>-->
                    </el-row>
                </div>
            </div>

        </el-dialog>
        <el-dialog
                :visible.sync="medicalVisitModelCoach"
                width="45%"
                :show-close="false"
                :before-close="handleClose"
                style="vertical-align: center;: #FFF9F3">
            <div>
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">选择辅导/协访
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click="saveModelInCoach">
                                确定
                            </el-button>
                            <el-button type="danger" size="small" @click="closeModelInCoach">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div style="margin-top: 20px;">
                    <el-row>
                        <el-col :span="24" style=" height: 300px;overflow: auto">
                            <el-col v-for="(item,i) in coachArrayModel"
                                    :span="24"
                                    style="border: 1px solid #979797;margin-bottom: 10px;"
                                    :style="{'background': item.onoff ? 'rgba(74,144,226,0.1)' : 'white'}"

                            >
                                <div  @click="coachImgClick(item)">
                                    <div style="width: 10%;height: 60px;float: left;text-align: center;line-height: 75px">
                                        <img v-if="item.onoff === true"
                                             :src="inCheck"/>
                                        <img v-else :src="noCheck"/>
                                    </div>
                                    <div style="width: 90%;float: left">
                                        <p
                                                style="margin: 22px 10px 10px;font-weight: bold;font-size: 18px;">{{item.value1}}
                                        </p>
                                    </div>
                                </div>

                            </el-col>
                        </el-col>
                    </el-row>
                </div>
            </div>

        </el-dialog>
    </div>
</template>

<script>
    import {AMapManager} from "vue-amap";
    import noCheck from "../../../../assets/images/noCheck.png";
    import inCheck from "../../../../assets/images/speakers.png";
    import http from "../../../../APIService/http";
    import imgUrl from "../../../../assets/images/mark_0.png";
    import draggable from 'vuedraggable'

    let amapManager = new AMapManager();
    export default {
        name: "weekday",
        props:{
            data:{
                type:Array,
                default:[]
            },
            mapId:{
                type:String,
                default:'map'
            },
            selectDate:{
                type:String,
                default:''
            },
            onOff:{
                type:Boolean,
                default:false
            }
        },
        data(){
            return{
                amapManager,
                zoom: 10,
                centers:[],
                center: [121.59996, 31.197646],
                lng:0,
                lat:0,
                plugin: [{
                    pName: 'ToolBar',
                    position:'RT',
                    locate:false,
                    events: {
                        init(instance) {

                        }
                    }

                }],
                medicalVisitModel:false,
                medicalVisitModelStore:false,
                medicalVisitModelDis:false,
                medicalVisitModelMee:false,
                medicalVisitModelCoach:false,
                institutionModel:{
                    institutionsArray:[],
                    institutionsHcpList:[]
                },
                storesArrayModel:[],
                disArrayModel:{
                    distributorArray:[],
                    contactArray:[]
                },
                meeArrayModel:[],
                coachArrayModel:[],
                noCheck : noCheck,
                inCheck : inCheck,
                copyInsArray:[],
                copyStoreArray:[],
                copyDisArray:[],
                copyMeeArray:[],
                copyCoachArray:[],
                selectInstitutionArray:[],
                form:{
                    institutionsArray:[],
                    retailstoreArray:[],
                    distributorArray:[],
                    meetingArray:[],
                    coachArray:[]
                },
                distance:0
            }
        },
        components:{
            draggable
        },
        filters:{
            titleFilter:function (value) {
                if (value === undefined || value ===''){
                    return ''
                } else {
                    return '-'+value
                }
            },
            filter_covegr:function (item) {
                if (item.calls == '0'&& item.campaigns == '0'){
                    return '本月尚未覆盖'
                } else {
                    let str =''
                    if (item.calls != '0'){
                        str = '本月已覆盖(医务拜访'
                    }
                    if (item.campaigns != '0'){
                        if (str != ''){
                            str = str + "、科室会"
                        } else {
                            str = str + "本月已覆盖(科室会"
                        }
                    }
                    if (str!=''){
                        str = str+")"
                    }
                    return str
                }
            }
        },
        methods: {
            init(array) {

                let insArr = []
                let storeArr = []
                let disArr = []
                let that = this
                var map = amapManager.getMap();
                //构造路线导航类
                map.clearMap()
                if(array.length>0){
                    for (let i = 0; i < array.length; i++) {
                        let obj = array[i]
                        if (obj.activity_category == 'HCP_CALL' || obj.activity_category == 'INSTITUTION_VISIT') {
                            insArr.push(obj)
                        } else if (obj.activity_category == 'STORE_INSPECTION') {
                            storeArr.push(obj)
                        } else if (obj.activity_category == 'CONTACT_CALL' || obj.activity_category == 'DISTRIBUTOR_VISIT') {
                            disArr.push(obj)
                        }
                    }
                    let newInsArr = this.filterFun(insArr, 'institution_id')
                    let newStoreArr = this.filterFun(storeArr, 'store_id')
                    let newDisArr = this.filterFun(disArr, 'distributor_id')
                    let mapArray = newInsArr.concat(newStoreArr, newDisArr)
                    mapArray.sort(this.compare('sort'))
                    if(mapArray.length>0){
                        this.center=[mapArray[0].lng,mapArray[0].lat];
                        mapArray.forEach((item,index)=>{

                            this.centers.push({
                                position: [item.lng, item.lat],
                                template: `<div style="width: 22px;color:#fff;height: 30px;text-align: center; font-size: 12px; line-height: 20px; background:url(${imgUrl})">${index+1}</div>`,

                            });
                        })
                        // if(mapArray.length>1){
                            //基本地图加载

                            var driving = new AMap.Driving({
                                map: map,
                                policy: AMap.DrivingPolicy.LEAST_TIME,
                            });

                            var Arr = mapArray.concat()
                            var waypointsArr = []

                            Arr.pop()
                            Arr.shift()
                            Arr.forEach(item=>{
                                waypointsArr.push(new AMap.LngLat(item.lng, item.lat))
                            })
                            // 根据起终点经纬度规划驾车导航路线
                            driving.search(new AMap.LngLat(mapArray[0].lng, mapArray[0].lat),
                                new AMap.LngLat(mapArray[mapArray.length-1].lng,mapArray[mapArray.length-1].lat),
                                {waypoints:waypointsArr},function(status,result) {
                                    //
                                    // console.log(result,9)
                                    // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/wapi/javascript-api/reference/route-search#m_DrivingResult
                                    if (status === 'complete') {
                                        that.distance = (result.routes[0].distance/1000).toFixed(1)
                                        // log.success('绘制驾车路线完成')
                                    } else {
                                        // log.error('获取驾车数据失败：' + result)
                                    }
                                }
                            );

                        // }
                    }else {
                        this.center = [121.59996, 31.197646]
                    }

                }

            },
            end(evt){
                this.$emit('sort',this.data)
            },
            deleteOne(item, i) {
                this.data.splice(i, 1)
                this.$emit('changeNum', item)
                this.init(this.data)
            },
            openMedicalVisitModel() {
                this.form.institutionsArray = []
                for (let i = 0; i < this.data.length; i++) {
                    let obj = this.data[i]
                    if (obj.activity_category == 'HCP_CALL' || obj.activity_category == 'INSTITUTION_VISIT') {
                        this.form.institutionsArray.push(obj)
                    }
                }
                this.copyInsArray = JSON.parse(JSON.stringify(this.form.institutionsArray))
                this.medicalVisitModel = true
                setTimeout(() => {
                    this.getInstitutionsList()
                }, 100)
            },
            openMedicalVisitModelStore() {
                this.form.retailstoreArray = []
                for (let i = 0; i < this.data.length; i++) {
                    let obj = this.data[i]
                    if (obj.activity_category == 'STORE_INSPECTION') {
                        this.form.retailstoreArray.push(obj)
                    }
                }
                setTimeout(() => {
                    this.getRetailstoreList()
                }, 100)
                this.copyStoreArray = JSON.parse(JSON.stringify(this.form.retailstoreArray))
                this.medicalVisitModelStore = true
            },
            openMedicalVisitModelDis() {
                this.form.distributorArray = []
                for (let i = 0; i < this.data.length; i++) {
                    let obj = this.data[i]
                    if (obj.activity_category == 'CONTACT_CALL' || obj.activity_category == 'DISTRIBUTOR_VISIT') {
                        this.form.distributorArray.push(obj)
                    }
                }
                this.copyDisArray = JSON.parse(JSON.stringify(this.form.distributorArray))
                this.medicalVisitModelDis = true
                setTimeout(() => {
                    this.getDistributorList()
                }, 100)

            },
            openMedicalVisitModelMee() {
                this.form.meetingArray = []
                for (let i = 0; i < this.data.length; i++) {
                    let obj = this.data[i]
                    if (obj.activity_category == 'CAMPAIGN') {
                        this.form.meetingArray.push(obj)
                    }
                }
                this.copyMeeArray = JSON.parse(JSON.stringify(this.form.meetingArray))
                this.medicalVisitModelMee = true
                setTimeout(() => {
                    this.getMeetingList()
                }, 100)
            },
            openMedicalVisitModelCoach() {
                this.form.coachArray = []
                for (let i = 0; i < this.data.length; i++) {
                    let obj = this.data[i]
                    if (obj.activity_category == 'COACHING') {
                        this.form.coachArray.push(obj)
                    }
                }
                this.copyCoachArray = JSON.parse(JSON.stringify(this.form.coachArray))
                this.medicalVisitModelCoach = true
                setTimeout(() => {
                    this.getCoachingList()
                }, 100)
            },
            closeModelIn() {
                this.medicalVisitModel = false
                this.form.institutionsArray = JSON.parse(JSON.stringify(this.copyInsArray))
                this.institutionModel.institutionsArray = []
                this.institutionModel.institutionsHcpList = []
            },
            closeModelInStore() {
                this.medicalVisitModelStore = false
                this.form.retailstoreArray = JSON.parse(JSON.stringify(this.copyStoreArray))
                this.storesArrayModel = []
            },
            closeModelInDis() {
                this.medicalVisitModelDis = false
                this.form.distributorArray = JSON.parse(JSON.stringify(this.copyDisArray))
                this.disArrayModel.distributorArray = []
                this.disArrayModel.contactArray = []
            },
            closeModelInMee() {
                this.medicalVisitModelMee = false
                this.form.meetingArray = JSON.parse(JSON.stringify(this.copyMeeArray))
                this.meeArrayModel = []
            },
            closeModelInCoach() {
                this.medicalVisitModelCoach = false
                this.form.coachArray = JSON.parse(JSON.stringify(this.copyCoachArray))
                this.coachArrayModel = []
            },
            async getInstitutionsList() {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                        owner_id: user.user_id,
                        city_id: [],
                        grade_array: [],
                    }
                    await http.post('/wapi/WeekPlan/getInstutionsList', data).then(res => {

                        let array1 = res.data.array
                        let array2 = this.form.institutionsArray
                        if (array2.length > 0) {
                            for (let i = 0; i < array1.length; i++) {
                                for (let j = 0; j < array2.length; j++) {
                                    array1[i].onoff = false
                                    if (array1[i].institution_id === array2[j].institution_id) {
                                        array1[i].onoff = true
                                        break
                                    }
                                }
                            }
                        } else {
                            for (let i = 0; i < array1.length; i++) {
                                array1[i].onoff = false
                            }
                        }
                        this.institutionModel.institutionsArray = array1
                        loading.close()
                    })
                } catch (e) {
                    loading.close()
                }
            },
            async getInstutionsHcpList(item) {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        institution_id: item.institution_id,
                        city_id: [],
                        segment_array: [],
                    }
                    await http.post('/wapi/WeekPlan/getInstutionsHcpList', data).then(res => {
                        if (res.success === true) {

                            let array1 = res.data.array
                            let array2 = this.form.institutionsArray
                            let array3 = []
                            for (let i = 0; i < array1.length; i++) {
                                array1[i].onoff = false
                                for (let j = 0; j < array2.length; j++) {
                                    if (array1[i].hcp_id === array2[j].hcp_id) {
                                        array1[i].onoff = true
                                        break
                                    }
                                }
                            }

                            this.institutionModel.institutionsHcpList = array1
                            loading.close()
                        }

                    })
                } catch (e) {
                    loading.close()
                }
            },
            async getRetailstoreList() {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                        owner_id: user.user_id,
                        city_id: [],
                        grade_array: [],
                    }
                    await http.post('/wapi/WeekPlan/getRetailstoreList', data).then(res => {

                        let array1 = res.data.array
                        let array2 = this.form.retailstoreArray
                        for (let i = 0; i < array1.length; i++) {
                            for (let j = 0; j < array2.length; j++) {
                                array1[i].onoff = false
                                if (array1[i].store_id === array2[j].store_id) {
                                    array1[i].onoff = true
                                    break
                                }
                            }
                        }
                        this.storesArrayModel = array1
                        loading.close()
                    })
                } catch (e) {
                    loading.close()
                }
            },
            async getDistributorList() {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                        owner_id: user.user_id,
                        city_id: [],
                        grade_array: [],
                    }
                    await http.post('/wapi/Business/getDistributorList', data).then(res => {

                        let array1 = res.data.array
                        let array2 = this.form.distributorArray
                        if (array2.length > 0) {
                            for (let i = 0; i < array1.length; i++) {
                                for (let j = 0; j < array2.length; j++) {
                                    array1[i].onoff = false
                                    if (array1[i].distributor_id === array2[j].distributor_id) {
                                        array1[i].onoff = true
                                        break
                                    }
                                }
                            }
                        } else {
                            for (let i = 0; i < array1.length; i++) {
                                array1[i].onoff = false
                            }
                        }

                        this.disArrayModel.distributorArray = array1
                        loading.close()
                    })
                } catch (e) {
                    loading.close()
                }
            },
            async getDistributorContact(item) {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        distributor_id: item.distributor_id,
                        city_id: [],
                        segment_array: [],
                    }
                    await http.post('/wapi/WeekPlan/getDistributorContact', data).then(res => {
                        if (res.success === true) {

                            let array1 = res.data.array
                            let array2 = this.form.distributorArray
                            let array3 = []
                            for (let i = 0; i < array1.length; i++) {
                                array1[i].onoff = false
                                for (let j = 0; j < array2.length; j++) {
                                    if (array1[i].contact_id === array2[j].contact_id) {
                                        array1[i].onoff = true
                                        break
                                    }
                                }
                            }

                            this.disArrayModel.contactArray = array1
                            loading.close()
                        }

                    })
                } catch (e) {
                    loading.close()
                }
            },
            async getMeetingList() {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                        owner_id: user.user_id,
                        city_id: [],
                        grade_array: [],
                    }
                    await http.post('/wapi/WeekPlan/getMeetingList', data).then(res => {

                        let array1 = res.data
                        let array2 = this.form.meetingArray
                        for (let i = 0; i < array1.length; i++) {
                            for (let j = 0; j < array2.length; j++) {
                                array1[i].onoff = false
                                if (array1[i].key === array2[j].key) {
                                    array1[i].onoff = true
                                    break
                                }
                            }
                        }
                        this.meeArrayModel = array1
                        loading.close()
                    })
                } catch (e) {
                    loading.close()
                }
            },
            async getCoachingList() {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                        owner_id: user.user_id,
                        city_id: [],
                        grade_array: [],
                    }
                    await http.post('/wapi/WeekPlan/getCoachingList', data).then(res => {
                        let array1 = res.data
                        let array2 = this.form.coachArray
                        for (let i = 0; i < array1.length; i++) {
                            for (let j = 0; j < array2.length; j++) {
                                array1[i].onoff = false
                                if (array1[i].key === array2[j].key) {
                                    array1[i].onoff = true
                                    break
                                }
                            }
                        }
                        this.coachArrayModel = array1
                        // console.log(this.coachArrayModel,11)
                        loading.close()
                    })
                } catch (e) {
                    loading.close()
                }
            },
            imgClick(item, str) {
                if (str) {
                    if (item.onoff === true) {
                        item.onoff = false
                        str = str

                    } else {
                        item.onoff = true
                        str = str
                    }
                } else {
                    if (item.onoff === true) {
                        item.onoff = false
                        str = 'inCheckHis'

                    } else {
                        item.onoff = true
                        str = 'noCheckHis'
                    }
                }

                if (str === 'inCheckIns') {
                    for (let i = 0; i < this.form.institutionsArray.length;) {
                        if (item.institution_id === this.form.institutionsArray[i].institution_id) {
                            this.form.institutionsArray.splice(i, 1)
                        } else {
                            i++
                        }
                    }
                    this.getInstutionsHcpList(item)
                    this.$forceUpdate()
                } else if (str === 'noCheckIns') {
                    let obj = {}

                    obj.institution_id = item.institution_id
                    obj.institution_name = item.institution_name
                    obj.account_id = item.account_id
                    obj.reference_id = item.institution_id
                    obj.reference_obj = item.reference_obj
                    obj.activity_category = 'INSTITUTION_VISIT'
                    obj.activity_type = ''
                    obj.account_id = item.account_id
                    obj.lng = item.lng
                    obj.lat = item.lat
                    obj.activity_date = this.selectDate
                    obj.sort = this.data.length
                    this.form.institutionsArray.push(obj)
                } else if (str === 'inCheckHis') {
                    for (let i = 0; i < this.form.institutionsArray.length; i++) {
                        if
                        ((item.institution_id === this.form.institutionsArray[i].institution_id) &&
                            (item.hcp_id === this.form.institutionsArray[i].hcp_id)) {
                            this.form.institutionsArray.splice(i, 1)
                        }
                    }
                    let onoff = false
                    for (let j = 0; j < this.form.institutionsArray.length; j++) {
                        if (item.institution_id === this.form.institutionsArray[j].institution_id) {
                            onoff = true
                        }
                    }
                    let array = {}

                    if (onoff === false) {
                        for (let o = 0; o < this.institutionModel.institutionsArray.length; o++) {
                            if (item.institution_id === this.institutionModel.institutionsArray[o].institution_id) {
                                array = this.institutionModel.institutionsArray[o]
                                array.activity_date = this.selectDate
                                array.lng = this.institutionModel.institutionsArray[o].lng
                                array.lat = this.institutionModel.institutionsArray[o].lat
                                array.sort = this.data.length
                                this.form.institutionsArray.push(array)
                            }
                        }
                    }


                } else if (str === 'noCheckHis') {

                    let onoff = true
                    for (let i = 0; i < this.form.institutionsArray.length; i++) {

                        if ((item.institution_id === this.form.institutionsArray[i].institution_id) && (this.form.institutionsArray[i].reference_obj === 'INSTITUTION')) {
                            this.form.institutionsArray.splice(i, 1)
                            break
                        }
                        if ((item.institution_id === this.form.institutionsArray[i].institution_id) &&
                            (item.hcp_id === this.form.institutionsArray[i].hcp_id)) {
                            onoff = false
                        } else {

                        }
                    }
                    if (onoff === true) {


                        let obj = {}
                        let objInsArray = {}
                        objInsArray.institution_id = item.institution_id
                        objInsArray.institution_name = item.institution_name
                        objInsArray.reference_obj = item.reference_obj
                        objInsArray.reference_id = item.hcp_id
                        objInsArray.dept_name = item.dept_name
                        objInsArray.hcp_id = item.hcp_id
                        objInsArray.hcp_name = item.hcp_name
                        objInsArray.activity_category = 'HCP_CALL'
                        objInsArray.activity_type = ''
                        objInsArray.account_id = item.account_id
                        objInsArray.activity_date = this.selectDate
                        objInsArray.hcpArray = []
                        objInsArray.lng = item.lng
                        objInsArray.lat = item.lat
                        objInsArray.sort = this.data.length
                        obj.account_id = item.account_id
                        obj.dept_name = item.dept_name
                        obj.hcp_id = item.hcp_id
                        obj.hcp_name = item.hcp_name
                        obj.reference_id = item.reference_id
                        obj.reference_obj = item.reference_obj
                        objInsArray.hcpArray.push(obj)
                        this.form.institutionsArray.push(objInsArray)
                        for (let j = 0; j < this.institutionModel.institutionsArray.length; j++) {
                            if (item.institution_id === this.institutionModel.institutionsArray[j].institution_id) {
                                if (this.institutionModel.institutionsArray[j].onoff === false) {
                                    this.institutionModel.institutionsArray[j].onoff = true
                                }
                            }
                        }

                    }
                }

            },
            storeImgClick(item) {
                let str = ''
                if (item.onoff === true) {
                    item.onoff = false
                    str = 'inCheckStore'

                } else {
                    item.onoff = true
                    str = 'noCheckStore'
                }

                if (str === 'inCheckStore') {
                    for (let i = 0; i < this.form.retailstoreArray.length;) {
                        if (item.store_id === this.form.retailstoreArray[i].store_id) {
                            this.form.retailstoreArray.splice(i, 1)
                        } else {
                            i++
                        }
                    }
                    this.$forceUpdate()

                } else if (str === 'noCheckStore') {
                    let obj = {}

                    obj.activity_category = 'STORE_INSPECTION'
                    obj.activity_type = ''
                    obj.account_id = item.account_id
                    obj.reference_id = item.store_id
                    obj.reference_obj = item.reference_obj
                    obj.store_id = item.store_id
                    obj.store_name = item.store_name
                    obj.lng = item.lng
                    obj.lat = item.lat
                    obj.activity_date = this.selectDate
                    obj.sort = this.data.length
                    this.form.retailstoreArray.push(obj)
                }
            },
            disImgClick(item, str) {

                if (str) {
                    if (item.onoff === true) {
                        item.onoff = false
                    } else {
                        item.onoff = true
                    }
                } else {
                    if (item.onoff === true) {
                        item.onoff = false
                        str = 'inCheckCot'
                    } else {
                        item.onoff = true
                        str = 'noCheckCot'
                    }
                }
                if (str === 'inCheckDis') {
                    for (let i = 0; i < this.form.distributorArray.length;) {
                        if (item.distributor_id === this.form.distributorArray[i].distributor_id) {
                            this.form.distributorArray.splice(i, 1)
                        } else {
                            i++
                        }
                    }
                    this.getDistributorContact(item)
                    this.$forceUpdate()

                } else if (str === 'noCheckDis') {
                    let obj = {}
                    obj.activity_category = 'DISTRIBUTOR_VISIT'
                    obj.activity_date = this.selectDate
                    obj.sort = this.data.length
                    obj.activity_type = ''
                    obj.account_id = item.account_id
                    obj.reference_id = item.distributor_id
                    obj.reference_obj = item.reference_obj
                    obj.distributor_id = item.distributor_id
                    obj.distributor_name = item.distributor_name
                    obj.lng = item.lng
                    obj.lat = item.lat
                    this.form.distributorArray.push(obj)
                } else if (str === 'inCheckCot') {
                    for (let i = 0; i < this.form.distributorArray.length; i++) {
                        if
                        ((item.distributor_id === this.form.distributorArray[i].distributor_id) &&
                            (item.contact_id === this.form.distributorArray[i].contact_id)) {
                            this.form.distributorArray.splice(i, 1)
                        }
                    }
                    let onoff = false
                    for (let j = 0; j < this.form.distributorArray.length; j++) {
                        if (item.distributor_id === this.form.distributorArray[j].distributor_id) {
                            onoff = true
                        }
                    }
                    let array = {}

                    if (onoff === false) {
                        for (let o = 0; o < this.disArrayModel.distributorArray.length; o++) {
                            if (item.distributor_id === this.disArrayModel.distributorArray[o].distributor_id) {
                                array = this.disArrayModel.distributorArray[o]
                                array.activity_date = this.selectDate
                                array.lng = this.disArrayModel.distributorArray[o].lng
                                array.lat = this.disArrayModel.distributorArray[o].lat
                                array.sort = this.data.length
                                this.form.distributorArray.push(array)
                            }
                        }
                    }

                } else if (str === 'noCheckCot') {
                    let onoff = true
                    for (let i = 0; i < this.form.distributorArray.length; i++) {

                        if ((item.distributor_id === this.form.distributorArray[i].distributor_id) && (this.form.distributorArray[i].reference_obj === 'DISTRIBUTOR')) {
                            this.form.distributorArray.splice(i, 1)
                            break
                        }
                        if ((item.distributor_id === this.form.distributorArray[i].distributor_id) &&
                            (item.contact_id === this.form.distributorArray[i].contact_id)) {
                            onoff = false
                        } else {

                        }
                    }
                    if (onoff === true) {


                        let obj = {}
                        let objDisArray = {}
                        objDisArray.distributor_id = item.distributor_id
                        objDisArray.distributor_name = item.distributor_name
                        objDisArray.reference_obj = "CONTACT"
                        objDisArray.reference_id = item.contact_id
                        objDisArray.contact_id = item.contact_id
                        objDisArray.contact_name = item.contact_name
                        objDisArray.activity_category = 'CONTACT_CALL'
                        objDisArray.activity_type = ''
                        objDisArray.activity_date = this.selectDate
                        objDisArray.sort = this.data.length
                        objDisArray.account_id = item.account_id ? item.account_id : ''
                        objDisArray.lng = item.lng
                        objDisArray.lat = item.lat
                        objDisArray.contactArray = []
                        obj.account_id = item.account_id
                        obj.contact_id = item.contact_id
                        obj.contact_name = item.contact_name
                        obj.reference_id = item.reference_id
                        obj.reference_obj = 'CONTACT'
                        objDisArray.contactArray.push(obj)
                        this.form.distributorArray.push(objDisArray)

                        for (let j = 0; j < this.disArrayModel.distributorArray.length; j++) {
                            if (item.distributor_id === this.disArrayModel.distributorArray[j].distributor_id) {
                                if (this.disArrayModel.distributorArray[j].onoff === false) {
                                    this.disArrayModel.distributorArray[j].onoff = true
                                }
                            }
                        }

                    }

                }
            },
            meeImgClick(item) {
                let str = ''
                if (item.onoff === true) {
                    item.onoff = false
                    str = 'inCheckMee'
                } else {
                    item.onoff = true
                    str = 'noCheckMee'
                }

                if (str === 'inCheckMee') {
                    for (let i = 0; i < this.form.meetingArray.length;) {
                        if (item.key === this.form.meetingArray[i].key) {
                            this.form.meetingArray.splice(i, 1)
                        } else {
                            i++
                        }
                    }
                } else if (str === 'noCheckMee') {
                    let obj = {}
                    obj.activity_category = 'CAMPAIGN'
                    obj.activity_date = this.selectDate
                    obj.sort = this.data.length
                    obj.activity_type = item.key
                    obj.key = item.key
                    obj.value1 = item.value1
                    obj.reference_obj = ''
                    obj.reference_id = ''
                    obj.account_id = ''
                    this.form.meetingArray.push(obj)
                }
                this.$forceUpdate()
            },
            coachImgClick(item) {
                let str = ''
                if (item.onoff === true) {
                    item.onoff = false
                    str = 'inCheckCoach'
                } else {
                    item.onoff = true
                    str = 'noCheckCoach'
                }

                if (str === 'inCheckCoach') {
                    for (let i = 0; i < this.form.coachArray.length;) {
                        if (item.key === this.form.coachArray[i].key) {
                            this.form.coachArray.splice(i, 1)
                        } else {
                            i++
                        }
                    }
                } else if (str === 'noCheckCoach') {
                    let obj = {}
                    obj.activity_category = 'COACHING'
                    obj.activity_date = this.selectDate
                    obj.sort = this.data.length
                    obj.activity_type = item.key
                    obj.key = item.key
                    obj.value1 = item.value1
                    obj.reference_obj = ''
                    obj.reference_id = ''
                    obj.account_id = ''
                    this.form.coachArray.push(obj)
                }
                this.$forceUpdate()
            },
            saveModelIn() {
                this.medicalVisitModel = false
                if (this.form.institutionsArray.length > 0) {
                    this.$emit('changeData', this.form.institutionsArray,this.data)
                }
            },
            saveModelInStore() {
                this.medicalVisitModelStore = false
                if (this.form.retailstoreArray.length > 0) {
                    this.$emit('changeData', this.form.retailstoreArray,this.data)
                }
            },
            saveModelInDis() {
                this.medicalVisitModelDis = false
                if (this.form.distributorArray.length > 0) {
                    this.$emit('changeData', this.form.distributorArray,this.data)
                }
            },
            saveModelInMee() {
                this.medicalVisitModelMee = false
                if (this.form.meetingArray.length > 0) {
                    this.$emit('changeData', this.form.meetingArray,this.data)
                }
            },
            saveModelInCoach() {
                this.medicalVisitModelCoach = false
                if (this.form.coachArray.length > 0) {
                    this.$emit('changeData', this.form.coachArray,this.data)
                }
            },
            compare(property){
                return function(a,b){
                    let value1 = a[property];
                    let value2 = b[property];
                    return value1 - value2;
                }
            },
            handleClose() {

            },
            colorFun(item) {
                if (item.calls == '0' && item.campaigns == "0") {
                    return '#ED3B3F'
                } else {
                    return '#4A90E2'
                }
            },
            filterFun(arr, val) {
                const res = new Map();
                return arr.filter((a) => !res.has(a[val]) && res.set(a[val], 1))
            }
        }
    }
</script>

<style scoped>
    #weekday:after{
        content: "";
        display: block;
        height: 0;
        clear:both;
        visibility: hidden;
    }
    #weekday .box-card {
        width: 100%;
        box-shadow:none;
        min-height:40px;
    }

</style>
<style>
    .amap-lib-marker-mid{
        display: none;
    }
    .amap-lib-marker-from{
        display: none;
    }
    .amap-lib-marker-to{
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/pages/calendar/components/components/weekday.vue